import { GetStaticProps } from 'next';

export type staticProps = {
	locale: string;
};

export const getStaticProps = (async (context) => {
	const locale = context.locale as string;
	return { props: { locale } };
}) satisfies GetStaticProps<staticProps>;

export default function Custom500() {
	return (
		<div style={{ padding: 'var(--spacing-13) 0', direction: 'ltr' }}>
			<h1 className="hero-small" style={{ textAlign: 'center' }}>
				500 - Server-side error occurred!
			</h1>
		</div>
	);
}
